import { SERVICE } from './constants'

export const OPEN_ADD_VENDOR_MODAL = `${SERVICE}/OPEN_ADD_VENDOR_MODAL`
export const OPEN_RESEND_INVITATION_MODAL = `${SERVICE}/OPEN_RESEND_INVITATION_MODAL`
export const OPEN_SAVE_NEW_SEARCH_MODAL = `${SERVICE}/OPEN_SAVE_NEW_SEARCH_MODAL`
export const CLOSE_MODAL = `${SERVICE}/CLOSE_MODAL`
